import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "customization"
    }}>{`Customization`}</h1>
    <h2 {...{
      "id": "how-to-completely-remove-the-seater-car-text-from-the-home-page"
    }}>{`How to completely remove the `}<inlineCode parentName="h2">{`Seater Car`}</inlineCode>{` text from the home page?`}</h2>
    <p>{`Please remove Seater Car text from,`}</p>
    <pre><code parentName="pre" {...{}}>{`wp-content/themes/turbo/redqframework/turbo-vc-addons/vc_templates/turbo_recent_products.php
wp-content/themes/turbo/redqframework/turbo-vc-addons/vc_templates/turbo_top_rated_prod
`}</code></pre>
    <h2 {...{
      "id": "how-to-remove-rating-filter-from-home-page"
    }}>{`How to remove `}<inlineCode parentName="h2">{`Rating Filter`}</inlineCode>{` from home page?`}</h2>
    <p>{`Please remove the rating list block from,`}</p>
    <pre><code parentName="pre" {...{}}>{`wp-content/themes/turbo/redqframework/turbo-vc-addons/vc_templates/turbo_isotope_car_grid.php
`}</code></pre>
    <p><img alt="RemoveRating.png" src={require("./images/RemoveRating.png")} /></p>
    <h2 {...{
      "id": "how-to-remove-the-pricing-info-flip-box"
    }}>{`How to remove the `}<inlineCode parentName="h2">{`Pricing Info`}</inlineCode>{` flip box?`}</h2>
    <p><img alt="RemoveHooks.png" src={require("./images/RemoveHooks.png")} /></p>
    <p>{`Please add this action hook on your theme functions.php`}</p>
    <p>{`remove_action('rnb_before_add_to_cart_form', 'rnb_price_flip_box', 10);`}</p>
    <h2 {...{
      "id": "how-to-change-the-order-of-rental-components-on-a-single-product-page"
    }}>{`How to change the order of rental components on a single product page?`}</h2>
    <p><img alt="SingleProductOrder.png" src={require("./images/SingleProductOrder.png")} /></p>
    <p>{`Please change the action hooks priority from,`}</p>
    <pre><code parentName="pre" {...{}}>{`wp-content/plugins/woocommerce-rental-and-booking/includes/rnb-template-hooks.php
`}</code></pre>
    <p><img alt="HooksPriority.png" src={require("./images/HooksPriority.png")} /></p>
    <h2 {...{
      "id": "how-to-remove-price-from-a-single-product-page"
    }}>{`How to remove `}<inlineCode parentName="h2">{`Price`}</inlineCode>{` from a single product page?`}</h2>
    <p><img alt="RemovePriceLabel.png" src={require("./images/RemovePriceLabel.png")} /></p>
    <p>{`Please remove h2 from these files,`}</p>
    <p>{`wp-content/themes/turbo/woocommerce/content-single-rental-product-right.php
wp-content/themes/turbo/woocommerce/content-single-rental-product-right.php`}</p>
    <p><img alt="RemovePrice.png" src={require("./images/RemovePrice.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      